<div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
  <!-- Metric Item Start -->
  <div class="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/3 md:p-6">
    <div class="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800" [innerHTML]="icons.groupIcon | safeHtml">
    </div>
    <div class="mt-5">
      @if (organizationId) {
        <span class="text-sm text-gray-500 dark:text-gray-400">Organization</span>
        <h4 class="mt-2 truncate font-bold text-gray-800 text-title-sm dark:text-white/90" [title]="organizationName">{{ organizationName }}</h4>
      } @else {
        <span class="text-sm text-gray-500 dark:text-gray-400">Total Organizations</span>
        <h4 class="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">{{ organizationsCount }}</h4>
      }
    </div>
  </div>
  <!-- Metric Item End -->

  <!-- Metric Item Start -->
  <div class="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/3 md:p-6">
    <div class="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800" [innerHTML]="icons.boxIconLine| safeHtml">
    </div>
    <div class="mt-5">
      <span class="text-sm text-gray-500 dark:text-gray-400">Total Surveys</span>
      <h4 class="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">{{ surveysCount }}</h4>
    </div>
  </div>
  <!-- Metric Item End -->
</div>